import Box from '@mui/material/Box';
import Image from 'next/image';

import styles from './TeamAvatars.module.scss';

const teamMembers = [
  {
    id: 1,
    image: '/images/avatars/ivan.webp',
    alt: 'Ivan',
    gradient: 'blue',
  },
  {
    id: 2,
    image: '/images/avatars/roko.webp',
    alt: 'Roko',
    gradient: 'gray',
  },
  {
    id: 3,
    image: '/images/avatars/ante.webp',
    alt: 'Ante',
    gradient: 'orange',
  },
  {
    id: 4,
    image: '/images/avatars/luka.webp',
    alt: 'Luka',
    gradient: 'green',
  },
  {
    id: 5,
    image: '/images/avatars/toni.webp',
    alt: 'Toni',
    gradient: 'pink',
  },
];

const TeamAvatars = () => (
  <Box className={styles.avatarsContainer}>
    {teamMembers.map(member => (
      <Box key={member.id} className={`${styles.avatar} ${styles[member.gradient]}`}>
        <Image src={member.image} alt={member.alt} fill className={styles.avatarImage} sizes="162px" quality={100} />
      </Box>
    ))}
  </Box>
);

export default TeamAvatars;
